import { makeReducer } from "../../../core/make-reducer";
import ViewerMethod from "../../../core/ViewerMethod";

export default makeReducer(ViewerMethod.GET_LIFETIME_PRINT_PAGES, (pages) =>
  pages.reduce((acc, cv) => {
    acc[cv.label] = true;
    return acc;
  }, {})
);
